module.exports = __webpack_public_path__ + "media/images/eyecatch-refund-sm-b8c29768c8784c190c57f017bc7f6472.svg";